import { Button } from 'palette/Button';
import { useTranslate } from '@common/Translations';
import { BEMBlock } from '@helpers/classnames';

export function ToggleFiltersVisibilityButton({
    displayAllFilters, hiddenElements, onClick
}) {
    const [block] = BEMBlock('toggle-filters-button');
    const translate = useTranslate();

    const icon = displayAllFilters ? 'palette_eye_disabled' : 'palette_eye';
    const label = displayAllFilters
        ? `${translate('filter_options_hide')}`
        : `${translate('filter_options_see_all')} +${hiddenElements}`;

    return (
        <Button
            className={block}
            iconName={icon}
            iconPosition="left"
            label={label}
            size="small"
            theme="secondary"
            onClick={onClick}
        />
    );
}
